import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Link, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { CellLabel, EntityImage } from '@shapeable/ui';
const cls = classNames('link-card-thumbnail');

// -------- Types -------->

// -------- Props -------->

export type LinkCardThumbnailProps = Classable & HasChildren & { 
  entity: Link;
};

export const LinkCardThumbnailDefaultProps: Omit<LinkCardThumbnailProps, 'entity'> = {

};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    position: relative;
  `,
});

const ThumbnailStyles = breakpoints({
  base: css`
   
  `,
});

const CellLabelStyles = breakpoints({
  base: css`
   position: absolute;
   top: 8px;
   left: 16px;
   color: ${theme.COLOR('light')};
   font-size: 0.7em;
   text-shadow: 0 4px 8px rgba(0, 0, 0, 2);
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Thumbnail: styled(EntityImage)`${ThumbnailStyles}`,
    Label: styled(CellLabel)`${CellLabelStyles}`,
};

export const LinkCardThumbnail: Shapeable.FC<LinkCardThumbnailProps> = (props) => {
  const { className, entity } = props;

  const { image, name } = entity || {};

  return (
    <My.Container className={cls.name(className)} >
      <My.Thumbnail entity={entity} />
      <My.Label>{name}</My.Label>
    </My.Container>
  )
};

LinkCardThumbnail.defaultProps = LinkCardThumbnailDefaultProps;
LinkCardThumbnail.cls = cls;